import { DashboardService } from "../dashboardService";
import { LocalStorageService } from "src/services/localStorageService";
import { CreationDateSortOptions, LocalStorageKeys, PurchaseOrderColumnHeader } from "src/enums";
import { PurchaseOrdersFilters } from "src/types";

class PurchaseOrderDashService extends DashboardService<
  PurchaseOrderColumnHeader,
  PurchaseOrdersFilters,
  CreationDateSortOptions,
  undefined
> {
  constructor(localStorageService: LocalStorageService) {
    super(localStorageService, LocalStorageKeys.PURCHASE_ORDER_DASH_SETTINGS);
  }
}

export { PurchaseOrderDashService };
